import React from "react";
import LatexRender from "../../../../../layout/LatexRender";

export default function Sidebar({
    question,
    hasSubmitted,
    setHasSubmitted,
    hasOutreached,
    setHasOutreached,
    handleNext,
    submitAnswer,
    feedback,
    elapsedSeconds,
    displayNumber,
    questionNumber
}) {
    return (
        <div className="contentCol">
          {/* Progress */}
          <h3 className="drillCounter">🧩 dRill {displayNumber}/10</h3>
          
          {/* Sidebar Box*/}
          <div className="card">
              {/* Top buttons */} 
              <div className="buttons">

                {/* 💡 Hint button */}
                <button 
                  onClick={() =>
                      !hasOutreached && questionNumber <=10 ? (
                          setHasOutreached(true)
                      ) : (
                          setHasOutreached(false)
                      )
                  }
                  className="buttonHint">
                    <img
                      src="/images/hint.png"
                      alt="hint"
                      className="h-5"
                    />
                    <span>hint</span>
                </button>

                {/* ➡️ Next button */}
                <button
                  onClick={handleNext}
                  className="buttonNext"
                >
                  ＞
                </button>
              
              </div>

              {/* Middle section (explanation and hint)*/}
              <div className="flex flex-col justify-center items-center font-nunito font-semibold text-center h-full">
                
                {/* Forklaring */}
                {!hasSubmitted && !hasOutreached && (
                    <span>
                      isolér <LatexRender math={`\\text{}x\\text{}`} />  - fjern alle tal fra <LatexRender math={`\\text{}x`} />'s side - ved at lave den omvendte regneoperation på begge sider af lighedstegnet
                    </span>
                  )
                }
                
                {/* Hint */}
                {!hasSubmitted && hasOutreached && (
                    <div className="flex flex-col text-center">
                        <span>
                          modsatte regneoperationer 👩‍⚕️:
                        </span>
                        <LatexRender math={`+\\qquad -`}/>
                        <LatexRender math={`\\cdot\\qquad /`}/>
                    </div>
                  )
                }

                {/* 🗯️ Feedback */}
                {feedback && (
                  <div
                    className={`feedback ${
                      feedback.correct
                        ? "feedbackCorrect"
                        : "feedbackWrong"
                    }`}
                  >
                    <img
                      src={feedback.correct ? "/images/logo_happy.png" : "/images/logo_sad.png"}
                      className="h-[2rem]"
                    />
                    <span>{feedback.message}</span>
                    
                  </div>
                )}

              </div>

              {/* Submit button*/}
              <button
                onClick={() =>
                  !hasSubmitted && questionNumber <= 10 && (
                      submitAnswer(),
                      setHasSubmitted(true)
                  )
                }
                className="buttonSubmit"
              >
                indsend svar
              </button>
          </div>

        </div>
    )
}